export default "__VITE_ASSET__DQenFHBA__"